import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Scanner } from '@yudiel/react-qr-scanner';

const LIFF_ID = process.env.REACT_APP_LIFF_ID;

const ScanPage = ({ onClose }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('scanning');
  const [error, setError] = useState(null);
  const processedRef = useRef(false);

  // Android → redirect ไป scan-bill ผ่าน LIFF URL (เพื่อให้ขอ camera permission ใหม่)
  useEffect(() => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    if (isAndroid && LIFF_ID) {
      window.location.href = `https://liff.line.me/${LIFF_ID}/game/bts/scan-bill`;
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const parseQrParams = (text) => {
    try {
      const url = new URL(text);
      return {
        customer: url.searchParams.get('customer'),
        receiptNo: url.searchParams.get('receiptNo'),
        partnerId: url.searchParams.get('partnerId'),
        sale: url.searchParams.get('sale'),
        sale_date: url.searchParams.get('sale_date'),
        sale_store: url.searchParams.get('sale_store'),
      };
    } catch {
      return null;
    }
  };

  const hasAllFields = (params) => {
    if (!params) return false;
    return ['customer', 'receiptNo', 'partnerId', 'sale_date', 'sale_store', 'sale']
      .every(k => !!params[k]);
  };

  const handleScan = (results) => {
    if (processedRef.current || !results || results.length === 0) return;
    const text = results[0]?.rawValue;
    if (!text) return;

    const params = parseQrParams(text);

    if (hasAllFields(params)) {
      processedRef.current = true;
      setStatus('redirecting');
      sessionStorage.setItem('bts_internal_scan', '1');
      onClose();
      navigate(`/game/bts/receipt?${new URLSearchParams(params).toString()}`);
      return;
    }

    try {
      const url = new URL(text);
      if (url.protocol.startsWith('http')) {
        processedRef.current = true;
        setStatus('redirecting');
        window.location.href = text;
        return;
      }
    } catch { /* not URL */ }

    setError('QR นี้ไม่ใช่ใบเสร็จ Big C');
    setTimeout(() => setError(null), 3000);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#000', display: 'flex', flexDirection: 'column', zIndex: 9999 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', zIndex: 10 }}>
        <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '50%', width: 36, height: 36, color: '#fff', fontSize: 18, cursor: 'pointer' }}>✕</button>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>สแกน QR บิล</span>
        <div style={{ width: 36 }} />
      </div>

      <div style={{ flex: 1, position: 'relative' }}>
        {status === 'scanning' && (
          <Scanner
            onScan={handleScan}
            onError={(err) => setError(err?.message || 'กล้อง error')}
            constraints={{ facingMode: 'environment' }}
            styles={{ container: { width: '100%', height: '100%' }, video: { objectFit: 'cover' } }}
            scanDelay={300}
          />
        )}
        {status === 'redirecting' && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>กำลังดำเนินการ...</div>
        )}
      </div>

      {error && (
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 20, padding: 24 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 20, maxWidth: 300, width: '100%', textAlign: 'center' }}>
            <p style={{ fontSize: 15, fontWeight: 700, margin: '0 0 10px' }}>⚠️ เกิดข้อผิดพลาด</p>
            <p style={{ fontSize: 13, color: '#666', margin: '0 0 16px' }}>{error}</p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
              <button onClick={() => { setError(null); processedRef.current = false; }} style={{ background: '#10C851', color: '#fff', border: 'none', borderRadius: 100, padding: '10px 24px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>ลองใหม่</button>
              <button onClick={onClose} style={{ background: '#888', color: '#fff', border: 'none', borderRadius: 100, padding: '10px 24px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>ปิด</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScanPage;
